import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { trackPage } from '../../../shared/services/utils/tracking/tracking.service';
// import { RevenueChartComponent } from './components/revenue-chart/revenue-chart.component';
// import { OccupancyRateChartComponent } from './components/occupancy-rate-chart/occupancy-rate-chart.component';
import { ReservationsUpdates } from './components/reservations-updates/reservations-updates.component';
import { SummaryCards } from './components/summary-cards/summary-cards.component';
import { withAuthorization } from '../../../shared/services/auth/with-authorization/with-authorization.component';
import { UserRole } from '../../../shared/enums/user-role.enum';

// import { PendingActionsComponent } from './components/pending-actions/pending-actions.component';

import { DoubleBookings } from './components/double-booking/double-booking.component';
// import { NewGlobalCalendar } from './components/global-calendar/NewGlobalCalendar';
import { APP_ROUTES, CALENDAR_PERMITTED_ROLES } from '../../../shared/config/routes-config';
import { useHistory } from 'react-router';
import Button, {
  ButtonSize,
  ButtonType
} from '../../../shared/components/core-ui/button/button.component';
// import { CalendarIcon, SummaryIcon } from '../../../ui/Icons';

export const HomeContainer = () => {
  useEffect(() => trackPage('dashboard'), []);

  return (
    <div className="flex w-full flex-col items-start justify-start md:min-h-[calc(100vh-45px)] bg-creams-50 md:px-8 md:py-12">
      {/* <ol
        className="flex gap-3 justify-center items-center overflow-x-auto w-full p-1 mb-2"
        aria-label="Dashboard tabs"
      >
        {tabs.map((tabKey) => {
          const isActive = activeTab === tabKey;
          const baseClass =
            'inline-flex items-center gap-2 px-4 py-2 whitespace-nowrap rounded-lg cursor-pointer select-none transition-all duration-150 focus:outline-none focus:ring-2';
          const activeClass = 'bg-primary-600 text-white shadow-elevation-1 focus:ring-primary-300';
          const inactiveClass =
            'text-primary-700 hover:text-primary-600 hover:bg-primary-50 focus:ring-primary-100';

          return (
            <li key={tabKey}>
              <button
                type="button"
                aria-pressed={isActive}
                onClick={() => setActiveTab(tabKey)}
                className={`${baseClass} ${isActive ? activeClass : inactiveClass}`}
              >
                <span className={isActive ? 'text-white' : 'text-primary-600'}>
                  {iconByTab[tabKey]}
                </span>
                <span>{tabKey}</span>
              </button>
            </li>
          );
        })}
      </ol> */}

      <div className="flex-1 w-full rounded-xl transition-all ease-in-out duration-200">
        {/* <div
          className={activeTab === 'Summary' ? 'block' : 'hidden'}
          aria-hidden={activeTab !== 'Summary'}
        > */}
        <div className="my-4 text-[2.5rem] font-bold text-[#566346]"></div>

        <Summary />

        {/* <PendingSection /> */}
        <DoubleBookingSummary />
        <ReservationsSummary />
        {/* </div> */}

        {/* <div
          className={activeTab === 'Calendar' ? 'block' : 'hidden'}
          aria-hidden={activeTab !== 'Calendar'}
        > */}
        <div className="mb-12 w-full rounded-lg bg-white">
          <NewGlobalCalendarRender />
        </div>
      </div>
    </div>
  );
};

export default connect()(HomeContainer);

// const OccupancyRate = withAuthorization(
//   [UserRole.ADMIN, UserRole.E_COMMERCE, UserRole.FINANCE_MANAGER],
//   true
// )(() => (
//   <div className="w-full rounded-lg bg-white py-8 md:w-[49%] md:m-2">
//     <OccupancyRateChartComponent />
//   </div>
// ));

// const MonthlyRevenue = withAuthorization(
//   [UserRole.ADMIN, UserRole.E_COMMERCE, UserRole.FINANCE_MANAGER],
//   true
// )(() => (
//   <div className="w-full rounded-lg bg-white py-8 md:w-[49%] md:m-2">
//     <RevenueChartComponent />
//   </div>
// ));

// const PendingSection = withAuthorization(
//   [
//     UserRole.E_COMMERCE,
//     UserRole.ECOMMERCE_SPECIALIST,
//     UserRole.ECOMMERCE_SENIOR_SPECIALIST,
//     UserRole.SALES_SPECIALIST,
//     UserRole.SALES_MANAGER,
//     UserRole.ADMIN,
//     UserRole.SUPER_ADMIN,
//     UserRole.FINANCE_MANAGER,
//     UserRole.FINANCE_SPECIALIST,
//     UserRole.RESERVATION_MANAGER,
//     UserRole.RESERVATION_AGENT,
//     UserRole.RESERVATIONS,
//     UserRole.HOSPITALITY_AGENT,
//     UserRole.GES,
//     UserRole.HOSPITALITY_MANAGER,
//     UserRole.HOUSE_KEEPING_MANAGER,
//     UserRole.OPERATION_MANAGER,
//     UserRole.COMMERCIAL_MANAGER,
//     UserRole.INVESTOR
//   ],
//   true
// )(() => <PendingActionsComponent />);

const ReservationsSummary = withAuthorization(
  [
    UserRole.E_COMMERCE,
    UserRole.ECOMMERCE_SPECIALIST,
    UserRole.ECOMMERCE_SENIOR_SPECIALIST,
    UserRole.SALES_SPECIALIST,
    UserRole.SALES_MANAGER,
    UserRole.ADMIN,
    UserRole.SUPER_ADMIN,
    UserRole.FINANCE_MANAGER,
    UserRole.FINANCE_SPECIALIST,
    UserRole.RESERVATION_MANAGER,
    UserRole.RESERVATION_AGENT,
    UserRole.RESERVATIONS,
    UserRole.HOSPITALITY_AGENT,
    UserRole.GES,
    UserRole.HOSPITALITY_MANAGER,
    UserRole.HOUSE_KEEPING_MANAGER,
    UserRole.OPERATION_MANAGER,
    UserRole.COMMERCIAL_MANAGER
  ],
  true
)(() => <ReservationsUpdates />);

const Summary = withAuthorization(
  [
    UserRole.E_COMMERCE,
    UserRole.ECOMMERCE_SPECIALIST,
    UserRole.ECOMMERCE_SENIOR_SPECIALIST,
    UserRole.SALES_SPECIALIST,
    UserRole.SALES_MANAGER,
    UserRole.ADMIN,
    UserRole.SUPER_ADMIN,
    UserRole.FINANCE_MANAGER,
    UserRole.FINANCE_SPECIALIST,
    UserRole.RESERVATION_MANAGER,
    UserRole.RESERVATION_AGENT,
    UserRole.RESERVATIONS,
    UserRole.HOSPITALITY_AGENT,
    UserRole.GES,
    UserRole.HOSPITALITY_MANAGER,
    UserRole.HOUSE_KEEPING_MANAGER,
    UserRole.OPERATION_MANAGER,
    UserRole.COMMERCIAL_MANAGER
  ],
  true
)(() => <SummaryCards />);

const DoubleBookingSummary = withAuthorization(
  [
    UserRole.E_COMMERCE,
    UserRole.ECOMMERCE_SPECIALIST,
    UserRole.ECOMMERCE_SENIOR_SPECIALIST,
    UserRole.SALES_SPECIALIST,
    UserRole.SALES_MANAGER,
    UserRole.ADMIN,
    UserRole.SUPER_ADMIN,
    UserRole.FINANCE_MANAGER,
    UserRole.FINANCE_SPECIALIST,
    UserRole.RESERVATION_MANAGER,
    UserRole.RESERVATION_AGENT,
    UserRole.RESERVATIONS,
    UserRole.HOSPITALITY_AGENT,
    UserRole.GES,
    UserRole.HOSPITALITY_MANAGER,
    UserRole.HOUSE_KEEPING_MANAGER,
    UserRole.OPERATION_MANAGER,
    UserRole.COMMERCIAL_MANAGER
  ],
  true
)(() => <DoubleBookings />);

// const NewGlobalCalendarRender = withAuthorization(
//   [
//     UserRole.E_COMMERCE,
//     UserRole.ECOMMERCE_SPECIALIST,
//     UserRole.ECOMMERCE_SENIOR_SPECIALIST,
//     UserRole.SALES_SPECIALIST,
//     UserRole.SALES_MANAGER,
//     UserRole.ADMIN,
//     UserRole.FINANCE_MANAGER,
//     UserRole.FINANCE_SPECIALIST,
//     UserRole.RESERVATION_MANAGER,
//     UserRole.RESERVATION_AGENT,
//     UserRole.RESERVATIONS,
//     UserRole.HOSPITALITY_AGENT,
//     UserRole.GES,
//     UserRole.HOSPITALITY_MANAGER,
//     UserRole.HOUSE_KEEPING_MANAGER,
//     UserRole.OPERATION_MANAGER,
//     UserRole.COMMERCIAL_MANAGER
//   ],
//   true
// )(() => <NewGlobalCalendar />);

const NewGlobalCalendarRender = withAuthorization(
  CALENDAR_PERMITTED_ROLES,
  true
)(() => {
  const history = useHistory();

  return (
    <section className="overflow-hidden rounded-lg  bg-white px-6 py-8 shadow-sm">
      <div className="flex flex-col items-center gap-4 px-5 py-6 text-center md:px-6">
        <div className="max-w-[560px] space-y-1">
          <p className="text-lg text-neutral-500">
            full calendar for a clearer view of scheduling, reservations, and availability.
          </p>
        </div>
        <Button
          type={ButtonType.primary}
          size={ButtonSize.large}
          className="!justify-center"
          classNameButton="!min-w-[220px] !h-[45px] !rounded-full !border-0 !bg-primary-500 !px-6 !py-3 !text-lg !font-semibold !text-white shadow-[0_12px_30px_rgba(86,99,70,0.18)] transition-all duration-200 hover:!bg-primary-400 hover:shadow-[0_16px_36px_rgba(86,99,70,0.22)]"
          onClick={() => history.push(APP_ROUTES.CALENDAR_MODULE.PATH)}
        >
          Open Full Calendar
        </Button>
      </div>
    </section>
  );
});
